var chunkToChildrenMap = {
	"1860": [
		5158
	],
	"4012": [
		5158,
		1156
	],
	"4129": [
		3675
	],
	"4444": [
		1727
	],
	"4717": [
		1471,
		5323
	],
	"7347": [
		1471
	],
	"7370": [
		8792
	],
	"7853": [
		612
	],
	"9455": [
		5158
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));